// PlayerPickerDropdown — `@`-mention athlete picker.
//
// Phase 3 Step 2c2 extraction. Symmetric to AutocompleteDropdown:
// pure consumer of `useDecisionEngine()` for visibility + highlight index;
// receives the already-filtered athlete list and the pick callback as props
// (same list is consumed by `onInputKeyDown` in the page for keyboard nav).
//
// Renders nothing when the dropdown should be closed.
import React from 'react';

import { useDecisionEngine } from './state/DecisionEngineContext';

export const PlayerPickerDropdown = ({ filteredAthletes, onPick }) => {
  const { state, dispatch } = useDecisionEngine();
  const { showPlayerPicker, playerPickerIdx } = state;
  if (!showPlayerPicker || filteredAthletes.length === 0) return null;

  return (
    <div
      className="absolute bottom-20 left-6 right-6 max-w-3xl mx-auto bg-white dark:bg-gray-900 border rounded-lg shadow-lg overflow-hidden"
      data-testid="player-picker"
    >
      {filteredAthletes.map((a, i) => (
        <button
          key={a.id}
          onClick={() => onPick(a)}
          onMouseEnter={() => dispatch({ playerPickerIdx: i })}
          className={`w-full text-left px-4 py-2 flex items-center gap-3 ${
            i === playerPickerIdx ? 'bg-indigo-50 dark:bg-indigo-950/40' : ''
          }`}
          data-testid={`player-picker-option-${a.id}`}
        >
          <span className="w-6 h-6 rounded-full bg-gray-200 dark:bg-gray-800 text-[10px] font-semibold flex items-center justify-center shrink-0">
            {(a.full_name || '?')[0]?.toUpperCase()}
          </span>
          <span className="text-sm truncate">{a.full_name}</span>
          {a.position && (
            <span className="text-xs text-gray-400 shrink-0 ml-auto">{a.position}</span>
          )}
        </button>
      ))}
      <div
        className="px-4 py-1.5 text-[10px] text-gray-400 dark:text-gray-500 border-t border-gray-100 dark:border-gray-800 bg-gray-50/60 dark:bg-gray-900/40"
        data-testid="player-picker-hint"
        aria-hidden="true"
      >
        <kbd className="font-mono px-1 rounded bg-gray-100 dark:bg-gray-800">↑</kbd>{' '}
        <kbd className="font-mono px-1 rounded bg-gray-100 dark:bg-gray-800">↓</kbd>{' '}
        to navigate ·{' '}
        <kbd className="font-mono px-1 rounded bg-gray-100 dark:bg-gray-800">Tab</kbd>/
        <kbd className="font-mono px-1 rounded bg-gray-100 dark:bg-gray-800">Enter</kbd>{' '}
        to select
      </div>
    </div>
  );
};
